import {
  useToast as useToastBase,
  toast as toastBase,
  success as successBase,
  error as errorBase,
  warning as warningBase,
  info as infoBase,
} from "@/components/ui/toast/use-toast";

export function useToast() {
  const { toasts, dismiss } = useToastBase();

  return {
    toasts,
    toast: toastBase,
    dismiss,
    success: successBase,
    error: errorBase,
    warning: warningBase,
    info: infoBase,
  };
}
